import {
  customTaskIdOf,
  type MedicalEvidenceCustomTask,
} from "@care-by-ella/contracts";

// TES-1380 (TES-1376 §3B) — a doctor's row that takes files is done when she
// sends it, not when a file arrives: "Uppladdad, ej inskickad" until then,
// so a file in the evidence list is never read as her answer before she
// submitted it.
export function customTaskBadge(
  task: Pick<MedicalEvidenceCustomTask, "status" | "uploads" | "completedAt">,
): string {
  if (task.status === "done") {
    return task.uploads > 0 && task.completedAt
      ? `Inskickad ${new Date(task.completedAt).toLocaleDateString("sv-SE")}`
      : "Klar";
  }
  return task.uploads > 0 ? "Uppladdad, ej inskickad" : "Saknas";
}

// TES-1380 (Ö-598, Simon 2026-10-15) — a file the doctor asked for as a
// completion is for the doctor only: the API refuses its bytes to anyone
// else, and the admin's support view shows that it exists without a link.
export function isCompletionUpload(fieldKey: string): boolean {
  return customTaskIdOf(fieldKey) !== null;
}
